"use strict";
exports.block = require('bem-cn');
//# sourceMappingURL=block.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/react/block.js
// module id = 467
// module chunks = 0